
import httpClient from "../../services/http";


//getAllWarrantyDetails
export const getAllWarrantyDetails = () =>
  httpClient.get(`/utils-service/warranty_details`);
